import InstitutionFuturesDecisionMakerForm from '@/features/institution/futures/decision-maker/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionFuturesDecisionMakerPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="decisionMaker" detailsType={INSTITUTION_DETAILS_TYPE.FUTURES}>
      <InstitutionFuturesDecisionMakerForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionFuturesDecisionMakerPage.displayName = 'InstitutionFuturesDecisionMakerPage';

export default InstitutionFuturesDecisionMakerPage;
